const gradients = [
  'from-electric-blue to-cyan-400',
  'from-electric-purple to-violet-400',
  'from-pink-500 to-rose-400',
  'from-emerald-400 to-teal-400',
  'from-amber-400 to-orange-400',
  'from-sky-400 to-blue-500',
  'from-fuchsia-400 to-pink-500',
  'from-lime-400 to-emerald-500',
]

function getInitials(name: string) {
  return name
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}

interface Props {
  name: string
  logo?: string
  gradient?: string
  index?: number
  size?: 'sm' | 'md' | 'lg'
}

export default function ClientLogo({ name, logo, gradient, index = 0, size = 'md' }: Props) {
  const sizeMap = { sm: 'w-12 h-12 text-sm', md: 'w-16 h-16 text-base', lg: 'w-20 h-20 text-lg' }
  const fontMap = { sm: 'text-sm', md: 'text-lg', lg: 'text-2xl' }
  const initials = getInitials(name)
  const grad = gradient || gradients[index % gradients.length]

  if (logo) {
    return (
      <img
        src={logo}
        alt={name}
        className={`${sizeMap[size]} object-contain rounded-xl bg-white/5 p-2 border border-white/10`}
        loading="lazy"
      />
    )
  }

  return (
    <div
      className={`${sizeMap[size]} rounded-xl bg-gradient-to-br ${grad} p-0.5 shadow-lg`}
    >
      <div className="w-full h-full rounded-[10px] bg-gray-950 flex items-center justify-center">
        <span className={`${fontMap[size]} font-bold text-white drop-shadow-sm`}>
          {initials}
        </span>
      </div>
    </div>
  )
}
